import "core-js/modules/es.array.splice";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { initUserState } from '@vip-activity/business';
import { mapActions } from 'vuex';
import Header from './Header/Header.vue';
import Nav from './Nav/Nav.vue';
import GiveTicket from './GiveTicket/GiveTicket.vue';
import Ticket from './Ticket/Ticket.vue';
import Game from './Game/Game.vue';
import Call from './Call/Call.vue';
import Power from './Power/Power.vue';
import Book from './Book/Book.vue';
import Rank from './Rank/Rank.vue';
import Activity from './Activity/Activity.vue';
import Intro from './Intro/Intro.vue';
import Footer from './Footer/Footer.vue';
import FriendPop from './Pop/FriendPop/FriendPop.vue';
import LivePop from './Pop/LivePop/LivePop.vue';
import SharePop from './Pop/SharePop/SharePop.vue';
import PowerPop from './Pop/PowerPop/PowerPop.vue';
import GetPop from './Pop/GetPop/GetPop.vue';
import GetPowerPop from './Pop/GetPowerPop/GetPowerPop.vue';
import SelectPop from './Pop/SelectPop/SelectPop.vue';
import SupportPop from './Pop/SupportPop/SupportPop.vue';
import SendPop from './Pop/SendPop/SendPop.vue';
import MagicService from '../service/magic';
import ActorListPop from './Pop/ActorListPop/ActorListPop.vue';
import FanListPop from './Pop/FanListPop/FanListPop.vue';
export default {
  data: function data() {
    return {
      showSharePop: false,
      shareInfo: null,
      showPopArray: [],
      currentPop: null,
      diffUserList: [],
      showReceivePop: false,
      showLivePop: false,
      showGetPop: false,
      friendList: [],
      showFriendPop: false,
      showSendPop: false
    };
  },
  components: {
    Header: Header,
    Nav: Nav,
    GiveTicket: GiveTicket,
    Ticket: Ticket,
    Game: Game,
    Call: Call,
    Power: Power,
    Book: Book,
    Rank: Rank,
    Activity: Activity,
    Intro: Intro,
    Footer: Footer,
    LivePop: LivePop,
    SharePop: SharePop,
    FriendPop: FriendPop,
    PowerPop: PowerPop,
    GetPop: GetPop,
    GetPowerPop: GetPowerPop,
    SelectPop: SelectPop,
    SupportPop: SupportPop,
    SendPop: SendPop,
    ActorListPop: ActorListPop,
    FanListPop: FanListPop
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    getOrderList: 'getOrderList',
    getTicketInfo: 'getTicketInfo',
    getNow: 'getNow',
    refreshLotteryInfo: 'refreshLotteryInfo',
    issuePower: 'issuePower',
    getAbTestResult: 'getAbTestResult'
  })), {}, {
    // 检查是否可以领取增票逻辑
    checkGetState: function checkGetState() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.token) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (_this.loginService.isLogin) {
                  _context.next = 5;
                  break;
                }

                _this.loginService.openLogin();

                return _context.abrupt("return");

              case 5:
                if (!_this.hasTicket) {
                  _context.next = 9;
                  break;
                }

                _this.$refs.getPop.clearKey();

                _this.toast('你已拥有套票了，无需重复领取哦');

                return _context.abrupt("return");

              case 9:
                _this.nextShowPop('showGetPop');

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    checkPropsState: function checkPropsState() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.isPropsEnd) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (_this2.$refs.sendPop.curStar) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                if (_this2.loginService.isLogin) {
                  _context2.next = 7;
                  break;
                }

                _this2.loginService.openLogin();

                return _context2.abrupt("return");

              case 7:
                _this2.nextShowPop('showSendPop');

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 弹框队列  popName 不传，表示关闭pop
    nextShowPop: function nextShowPop(popName) {
      if (popName) {
        this.showPopArray.push(popName);
      } else {
        this.currentPop = null;
      }

      if (this.currentPop) return;
      var topPop = this.showPopArray.splice(0, 1)[0];

      if (topPop) {
        this[topPop] = true;
        this.currentPop = topPop;
        this.eventBus.$emit('stopVideo');
      } else {
        this.eventBus.$emit('playVideo');
      }
    },
    bindEvent: function bindEvent() {
      var _this3 = this;

      // 刷新购票信息
      this.eventBus.$on('refreshTicketInfo', function () {
        console.log('event:refreshTicketInfo:call');

        _this3.getOrderList();

        _this3.getTicketInfo(); // 刷新抽奖次数


        _this3.refreshLotteryInfo();
      }); // 弹出分享图

      this.eventBus.$on('launchShare', function (data) {
        console.log('event:launchShare:call', data);
        _this3.shareInfo = data;

        _this3.nextShowPop('showSharePop');
      }); // 领取列表弹框

      this.eventBus.$on('showReceive', function (data) {
        console.log('event:showReceive:call', data);
        _this3.friendList = data;

        _this3.nextShowPop('showFriendPop');
      }); // live弹窗

      this.eventBus.$on('showLivePop', function () {
        console.log('event:showLivePop:call');

        _this3.nextShowPop('showLivePop');
      }); // 预约

      this.eventBus.$on('bookAct', function () {
        console.log('bookAct:call');
        MagicService.bookAct();
      });
    },
    initState: function initState() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 检查 支付面板AB test
                _this4.getAbTestResult();

                if (!_this4.loginService.isLogin) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 4;
                return _this4.getOrderList();

              case 4:
                _context3.next = 6;
                return _this4.getTicketInfo();

              case 6:
                // 查询抽奖信息
                _this4.refreshLotteryInfo(); // 查询并下发魂力值


                _this4.issuePower(); // 账号一致性校验检查


                _this4.accountCheck.check();

              case 9:
                // 检查是否可以领取增票逻辑
                _this4.checkGetState();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }),
  created: function created() {
    this.getNow();
    this.bindEvent();
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return initUserState();

            case 2:
              _this5.initState();

              _this5.checkPropsState();

              _this5.$report.ready();

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};